// main公用
export const INIT_USER_INFO = 'INIT_USER_INFO'
// 首页
export const HOME_INIT_PRODUCT = 'HOME_INIT_PRODUCT'
// order
export const ORDER_SET_PAID_LIST = 'ORDER_SET_PAID_LIST'
export const ORDER_SET_UNPAID_LIST = 'ORDER_SET_UNPAID_LIST'
export const ORDER_SET_ID = 'ORDER_SET_ID'
export const ORDER_SET_DETAIL = 'ORDER_SET_DETAIL'
export const ORDER_SET_INVOICE = 'ORDER_SET_INVOICE'
export const ORDER_SET_FULLNAME = 'ORDER_SET_FULLNAME'
export const ORDER_SET_INVOICE_STATUS = 'ORDER_SET_INVOICE_STATUS'
export const SIGN_PRE_PAYMENT_STATUS = 'SIGN_PRE_PAYMENT_STATUS'
export const SIGN_CONTRACT_STATUS = 'SIGN_CONTRACT_STATUS'
export const VERIFICATION_STATUS = 'VERIFICATION_STATUS'

// store
export const STORE_INIT_SERVICE = 'STORE_INIT_SERVICE'
export const STORE_SET_ORDER_PRICE = 'STORE_SET_ORDER_PRICE'
export const STORE_RESET_ORDER_PRICE = 'STORE_RESET_ORDER_PRICE'
export const CLIENT_VERIFY_INFO = 'CLIENT_VERIFY_INFO'
export const CLIENT_FADADA_VERIFY_INFO = 'CLIENT_FADADA_VERIFY_INFO'
export const IS_CHILD_ACCOUNT = 'IS_CHILD_ACCOUNT'
export const CHILD_ACCOUNT_ERR_MSG = 'CHILD_ACCOUNT_ERR_MSG'
export const STORE_ORDER_PRODUCT_ID = "STORE_ORDER_PRODUCT_ID";
export const STORE_CID_LIST = "STORE_CID_LIST";
export const STORE_UNSUBMIT_STATUS = "STORE_UNSUBMIT_STATUS";

// voucher
export const VOUCHER_LIST = 'VOUCHER_LIST'

// appointment
export const APPOINTMENT_INFO = 'APPOINTMENT_INFO'

export const NOW_SERVE_TIME = 'NOW_SERVE_TIME'
